import { DateTime } from 'luxon';
import { useState } from 'react';
import { useInterval } from 'usehooks-ts';

import TimeDisplay from './TimeDisplay';

// Time above which the text will have an alert color to sign the stylist that they are taking too long!
const CUTTING_TIME_LIMIT_SECONDS = 30 * 60;

type Props = {
  startedAt: string;
};

export default function ServiceTime({ startedAt }: Props): React.ReactElement {
  const startedAtTime = DateTime.fromISO(startedAt);
  const computedTime = () => DateTime.now().diff(startedAtTime, 'seconds').as('seconds');

  const [cuttingTime, setCuttingTime] = useState<number>(computedTime());

  useInterval(() => {
    setCuttingTime(computedTime());
  }, 5000);

  const isOverLimit = cuttingTime > CUTTING_TIME_LIMIT_SECONDS;

  return (
    <TimeDisplay
      title="Cutting time"
      time={cuttingTime}
      className={isOverLimit ? 'text-red-500' : ''}
    />
  );
}
